<template>
  <div class="flex">
    <h1>Zakazivanje</h1>
    <v-card class="calendar-card">
      <v-btn flat elevation="0" outlined @click="calendarToToday">Danas</v-btn>
      <v-btn icon elevation="0" @click="calendarPrev"
        ><v-icon>mdi-chevron-left</v-icon></v-btn
      >
      <v-btn icon elevation="0" @click="calendarNext"
        ><v-icon>mdi-chevron-right</v-icon></v-btn
      >
      <span v-if="true">{{ calendarTitle }}</span>
      <v-calendar
        class="calendarr"
        v-model="calendarFocus"
        ref="calendar"
        type="week"
        locale="sr-LATN"
        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
        :events="events"
        @change="handleCalendarChange"
        @click:time="createEvent"
        @mousedown:event="startEventDrag"
        @mouseup:event="endEventDrag"
      >
        <template v-slot:day-body="{ date, week }" @click="log(date, week)">
          <div
            class="calendar-line"
            :class="{ first: date === week[0].date }"
            :style="{ top: nowY }"
          ></div>
        </template>
      </v-calendar>
      <schedule-card></schedule-card>
    </v-card>
  </div>
</template>

<script>
import ScheduleCard from "../components/ScheduleCard.vue";

export default {
  components: {
    ScheduleCard,
  },
  data() {
    return {
      calendarTitle: "",
      calendarFocus: "",
      calendarReady: false,
      events: [],
    };
  },
  mounted() {
    this.calendarReady = true;
    this.updateTime();
    this.$refs.calendar.checkChange();
    this.calendarTitle = this.$refs.calendar.title;
  },
  methods: {
    calendarPrev() {
      this.$refs.calendar.prev();
      console.log("lmao", this.$refs);
    },
    calendarNext() {
      this.$refs.calendar.next();
    },
    calendarToToday() {
      this.calendarFocus = "";
    },
    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);

      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
    log(date, week) {
      console.log({ date, week });
    },
    handleCalendarChange() {
      this.calendarTitle = this.$refs.calendar.title;
    },
    toTime(tms) {
      return new Date(
        tms.year,
        tms.month - 1,
        tms.day,
        tms.hour,
        tms.minute
      ).getTime();
    },
    createEvent(tms) {
      console.log(tms);
      // const first = new Date(firstTimestamp - (firstTimestamp % 900000))
      //     const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
      //     const second = new Date(first.getTime() + secondTimestamp)
      this.events.push({
        name: "Lola",
        start: this.toTime(tms),
        end: this.toTime({ ...tms, hour: tms.hour + 1 }),
        timed: true,
      });
    },
    openScheduleCard() {},
    startEventDrag() {},
    endEventDrag() {},
  },
  computed: {
    cal() {
      return this.calendarReady ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + "px" : "-10px";
    },
  },
};
</script>

<style scoped>
.calendar-card {
  height: 90vh;
}

.calendarr {
  height: 100%;
}

.flex {
  /* height: 100vh; */
}

.calendar-line {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;
}
.first::before {
  content: "";
  position: absolute;
  background-color: #ea4335;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: -5px;
  margin-left: -6.5px;
}

.schedule-card {
  width: 30%;
  min-height: 50vh;
  margin-left: 2%;
}
</style>
